/* eslint-disable indent */
import {
  AccordionSummary,
  Grid,
  Input,
  NativeSelect,
  TextareaAutosize,
  Typography,
} from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Paper from '@material-ui/core/Paper';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import InputMask from 'react-input-mask';
import { useHistory, useParams } from 'react-router-dom';
import Select from 'react-select';
import { toast } from 'react-toastify';
import Loading from '../../../components/Loading';
import Header from '../../../layout/Header';
import Subheader from '../../../layout/Subheader';
import api from '../../../services/api';
import { handleErrorRequest } from '../../../utils/errorsValidation';
import { formatDateTimeToRender, slugify } from '../../../utils/functions';
import '../pagination.style.css';
import { Anchors } from './components/Anchors';
import { Anotations } from './components/Anotations';
import { BankAccount } from './components/BankAccount';
import { ContactGroup } from './components/ContactGroup';
import { Exceptions } from './components/Exceptions';
import useStyles from './style';
import { ContactAssGroup } from './components/ContactAssGroup';
import { ContractMasterAssGroup } from './components/ContractMasterAssGroup';

export function Provider() {
  const history = useHistory();
  const re = /^([\d]{2})\.*([\d]{3})-*([\d]{3})/;
  const classes = useStyles();
  const { id } = useParams();

  const [auxLoading, setAuxLoading] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const [isLoadingCities, setLoadingCities] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isRegister, setIsRegister] = useState(false);
  const [getErros, setErros] = useState([]);

  const [provider, setProvider] = useState([]);
  const [formValues, setFormValues] = useState({
    tipoPessoa: 'Fisica',
    status: 'Pendente',
  });

  const [selectedGroup, setSelectedGroup] = useState({});

  const [estados, setEstados] = useState([]);
  const [classifications, setClassifications] = useState([]);
  const [groups, setGroups] = useState([]);
  const [groupsSelect, setGroupsSelect] = useState([]);
  const [groupNameInput, setGroupNameInput] = useState('');
  const [frequency, setFrequency] = useState('');

  const [activityBranches, setActivityBranches] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [municipioId, setMunicipioId] = useState(null);

  const fetchCity = async (stateId) => {
    if (!stateId) return;
    setLoadingCities(true);
    setAuxLoading(true);
    const searchCities = await api.get(`Municipios/ConsultarEstadoId?id=${stateId}&status=Ativo`);
    setMunicipios(searchCities.data.resposta);
    let selectedCity;
    if (formValues.cidade) {
      let cleanCityString = slugify(formValues.cidade.toUpperCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace("'", '´'))
      selectedCity = searchCities.data.resposta.filter((city) => city.municipio === cleanCityString)[0];
    }
    setFormValues((inputs) => ({
      ...inputs,
      municipioId: selectedCity?.municipioId,
    }));
    setLoadingCities(false);
    setAuxLoading(false);
  };

  const fetchInformation = async () => {
    const res = await api.get('ClassificacoesFornecedores/Consultar?status=Ativo');
    setClassifications(res.data.resposta);
    const act = await api.get('RamosAtividades/Consultar?status=Ativo');
    setActivityBranches(act.data.resposta);
    fetchGroups();
  };

  const fetchGroups = async (groupName = groupNameInput) => {
    setGroupsSelect([{ value: 0, label: 'Buscando fornecedor...' }]);
    const grp = await api.get(
      `GruposFornecedores/ConsultarGridCadastro?itensPorPagina=200&paginaInicial=0&grupo=${groupName}&status=Ativo`,
    );
    setGroups(grp.data.resposta);
    setGroupsSelect(
      grp.data.resposta.map((group) => ({ value: group.grupoFornecedorId, label: group.grupo })),
    );
  };

  const handleInputChange = (event, value) => {
    event.persist();
    setFormValues((inputs) => ({ ...inputs, [event.target.name]: value || event.target.value }));
  };

  const updateProvider = async (payload) => {
    const payloadUpadte = {
      ...payload,
      fornecedorId: Number(id),
      dataAtualizacao: formValues.dataAtualizacao,
      ...(!formValues.municipioId && { municipioId: Number(municipioId) }),
    };
    const response = await api.put('Fornecedores', payloadUpadte);
    if (response.data.status !== 'Inconsistencia') {
      toast.success('Fornecedor alterado com sucesso!');
      setFormValues(response.data.resposta);
      setProvider(response.data.resposta);
    } else {
      setErros(handleErrorRequest(response));
    }
  };

  const createProvider = async (payload) => {
    try {
      const response = await api.post('Fornecedores', payload);
      if (response.data.status !== 'Inconsistencia') {
        toast.success('Fornecedor criado com sucesso!');
        setFormValues(response.data.resposta);
        history.push(`/app/fornecedor/${response.data.resposta.fornecedorId}/editar`);
      } else {
        setErros(handleErrorRequest(response));
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const onSubmit = async () => {
    let cpfCnpj = {};
    if (selectedGroup?.tipoPessoa && formValues?.filialCNPJ) {
      cpfCnpj = {
        cnpjCpf:
          selectedGroup?.tipoPessoa === 'Juridica'
            ? `${selectedGroup?.raizCnpjCpf}/${
                formValues?.filialCNPJ.split('/')[1] ?? formValues?.filialCNPJ
              }`
            : selectedGroup.raizCnpjCpf,
      };
    }
    if (selectedGroup.tipoPessoa === 'Fisica') {
      cpfCnpj = { cnpjCpf: selectedGroup.raizCnpjCpf };
    }
    if (formValues.classificacaoFornecedorId === undefined) {
      toast.error('É preciso preencher a classificacao o fornecedor.');
      return;
    };
    if (formValues.cnpjCpf === '') {
      toast.error('É preciso preencher o CNPJ/CPF');
      return;
    };
    const classificationLabel = classifications.find(
      (el) => el.classificacaoFornecedorId === formValues.classificacaoFornecedorId,
    ).classificacao;
    const formObj = {
      ...formValues,
      ...cpfCnpj,
      classificacao: classificationLabel,
      dataUltimaProposta: isRegister ? null : formValues.dataUltimaProposta,
      dataUltimaAprovacao: isRegister ? null : formValues.dataUltimaAprovacao
    };
    isRegister ? createProvider(formObj) : updateProvider(formObj);
  };

  const getInfoForForm = async () => {
    try {
      const searchStates = await api.get('Estados/Consultar?status=Ativo');
      setEstados(searchStates.data.resposta);
      fetchProviderById(searchStates.data.resposta.estadoId);
    } catch (err) {
      if (err?.response?.data?.resposta?.[0]) {
        toast.error(err.response.data.resposta[0].message);
      } else {
        toast.error('Detectamos um problema interno! tente novamente em instantes.');
      }
    }
    setLoading(false);
  };

  const fetchProviderById = async (providerId) => {
    if (!providerId) return;
    setLoading(true);
    setAuxLoading(true);
    const res = await api.get(`Fornecedores/ConsultarId?id=${providerId}`);
    setProvider(res.data.resposta);
    const grpProvi = await api.get(
      `GruposFornecedores/ConsultarId?id=${res.data.resposta.grupoFornecedorId}`,
    );
    fetchCity(res.data.resposta?.estadoId);
    setFormValues({
      ...res.data.resposta,
      filialCNPJ: res.data.resposta.cnpjCpf.split('/')[1] ?? '',
    });
    setMunicipioId(res.data.resposta?.municipioId);
    setSelectedGroup({
      tipoPessoa: res.data?.resposta?.tipoPessoa ?? '',
      raizCnpjCpf: grpProvi.data.resposta.raizCnpjCpf ?? '',
      filialCNPJ: res.data.resposta.cnpjCpf.split('/')[1] ?? '',
      produtorRural: grpProvi.data.resposta.produtorRural,
    });
    setLoading(false);
    setAuxLoading(false);
  };

  const findCep = async (cep) => {
    cep = cep.replace('-', '').replace('.', '');
    setAuxLoading(true);
    const response = await axios.get(`https://viacep.com.br/ws/${cep}/json`);
    const { logradouro, bairro, localidade, uf } = response.data;
    const selectedUF = estados.filter((estado) => estado.uf === uf)[0];
    if(formValues.estadoId == selectedUF?.estadoId) {
      let selectedCity;
      if (localidade) {
        let cleanCityString = slugify(localidade.toUpperCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace("'", '´'))
        selectedCity = municipios.filter((city) => city.municipio === cleanCityString)[0];
      }
      setFormValues((inputs) => ({
        ...inputs,
        logradouro,
        bairro,
        cidade: localidade,
        estadoId: selectedUF?.estadoId,
        municipioId: selectedCity?.municipioId,
      }));
    } else {
      setFormValues((inputs) => ({
        ...inputs,
        logradouro,
        bairro,
        cidade: localidade,
        estadoId: selectedUF?.estadoId,
      }));
    }
    setAuxLoading(false);
  };

  const fetchInfoRegister = async () => {
    setIsRegister(true);
    const searchStates = await api.get('Estados/Consultar');
    setEstados(searchStates.data.resposta);
  };

  const handleGroupProviderSelect = (e) => {
    if (e.value === 0) return;
    const res = groups.find((group) => group.grupoFornecedorId === e.value);
    setFormValues((inputs) => ({
      ...inputs,
      tipoPessoa: res.tipoPessoa
    }));
    setSelectedGroup(res);
    setFrequency(res.frequencia);
    setFormValues((prev) => ({ ...prev, grupoFornecedorId: e.value }));
  };

  useEffect(() => {
    fetchCity(formValues?.estadoId);
  }, [formValues?.estadoId]);

  useEffect(() => {
    getInfoForForm();
    fetchInformation();
    if (window.location.pathname.includes('cadastrar')) {
      setIsEditing(true);
      return fetchInfoRegister();
    }
    if (id) {
      setIsEditing(window.location.pathname.includes('editar'));
      fetchProviderById(id);
    }
  }, [id]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchGroups();
    }, 700);

    return () => clearTimeout(delayDebounceFn);
  }, [groupNameInput]);

  return (
    <div className={classes.root}>
      <Header />
      {isEditing ? (
        <Subheader
          title={`${isRegister ? 'Cadastrando' : 'Atualizando'} fornecedor ${
            isRegister ? '' : '-'
          } ${provider?.nomeFantasia ?? ''}`}
          isDisabled={auxLoading || isLoading}
          back="/app/fornecedores"
          loading={isLoading}
          submit={onSubmit}
          submitText={`${isRegister ? 'Cadastrar' : 'Atualizar'}`}
        />
      ) : (
        <Subheader
          back="/app/fornecedores"
          loading={isLoading}
          title={`Visualizando fornecedor - ${provider?.nomeFantasia ?? ''}`}
        />
      )}
      <div className={classes.content}>
        <div className={classes.rootForm}>
          {isLoading ? (
            <Loading />
          ) : (
            <div>
              <form onSubmit={onSubmit}>
                <Accordion defaultExpanded>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.summary}>
                    <Typography className={classes.heading}>Informações</Typography>
                  </AccordionSummary>
                  <AccordionDetails className={classes.details}>
                    <Grid container>
                      <Grid item xs={6}>
                        <label className={classes.label}>ID</label>
                        <Paper className={classes.medium} elevation={0}>
                          <Input
                            className={classes.input}
                            value={formValues.fornecedorId}
                            readOnly
                            disabled={!isEditing}
                          />
                        </Paper>
                      </Grid>

                      <Grid item xs={6}>
                        <label className={classes.label}>Status</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={formValues?.status}
                            name="status"
                            onChange={handleInputChange}
                            disabled={!isEditing}
                            error={getErros.includes('Status')}
                            onBlur={(event) =>
                              getErros.includes('Status') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'Status';
                                }),
                              )
                            }
                          >
                            <option value="Ativo">Ativo</option>
                            <option value="Inativo">Inativo</option>
                            <option value="Pendente">Pendente</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>

                      <Grid item xs={6}>
                        <label className={classes.label}>Grupo</label>
                        <Paper
                          className={classes.medium}
                          elevation={0}
                          style={{
                            borderBottom: getErros.includes('GrupoFornecedorId')
                              ? 'red solid 2px'
                              : '',
                          }}
                        >
                          {isRegister || Number(provider?.grupoFornecedorId) === 1 ? (
                            <Select
                              options={[{ value: 0, label: 'FALTA PREENCHER' }, ...groupsSelect]}
                              onChange={handleGroupProviderSelect}
                              onInputChange={(e) => setGroupNameInput(e.toUpperCase())}
                              classNamePrefix="react-select"
                              className={classes.input}
                              placeholder="Selecione um grupo"
                              onBlur={(event) =>
                                getErros.includes('GrupoFornecedorId') &&
                                setErros(
                                  getErros.filter(function (item) {
                                    return item !== 'GrupoFornecedorId';
                                  }),
                                )
                              }
                            />
                          ) : (
                            <Input
                              style={{ textTransform: 'uppercase !important' }}
                              className={classes.input}
                              classes={{ input: classes.inputText }}
                              placeholder="Razão Social"
                              onChange={handleInputChange}
                              value={formValues?.grupo || provider?.grupo}
                              name="grupoFornecedorId"
                              disabled={!isEditing}
                              readOnly
                            />
                          )}
                        </Paper>
                      </Grid>

                      <Grid item xs={6}>
                        <label className={classes.label}>Tipo Pessoa</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={selectedGroup?.tipoPessoa}
                            name="tipoPessoa"
                            onChange={handleInputChange}
                            disabled
                          >
                            <option value="Fisica">Fisica</option>
                            <option value="Juridica">Jurídica</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>

                      {selectedGroup?.tipoPessoa !== 'Juridica' ||
                      formValues?.tipoPessoa !== 'Juridica' ? (
                        <Grid item xs={6}>
                          <label className={classes.label}>CPF</label>
                          <Paper className={classes.medium} elevation={0}>
                            <InputMask
                              mask="999.999.999-99"
                              value={selectedGroup?.raizCnpjCpf || formValues?.cnpjCpf}
                              disabled={!isRegister || !isEditing}
                              name="cnpjCpf"
                              onChange={handleInputChange}
                              onBlur={(event) =>
                                getErros.includes('CnpjCpf') &&
                                setErros(
                                  getErros.filter(function (item) {
                                    return item !== 'CnpjCpf';
                                  }),
                                )
                              }
                            >
                              {() => (
                                <Input
                                  className={classes.input}
                                  placeholder="CPF"
                                  name="cnpjCpf"
                                  error={getErros.includes('CnpjCpf')}
                                />
                              )}
                            </InputMask>
                          </Paper>
                        </Grid>
                      ) : isEditing ? (
                        <Grid item xs={6}>
                          <label className={classes.label}>CNPJ</label>
                          <div className={classes.cnpjBox}>
                            <Paper className={classes.medium} elevation={0}>
                              <InputMask
                                mask="99.999.999/"
                                value={selectedGroup?.raizCnpjCpf}
                                disabled
                              >
                                {() => <Input className={classes.input} />}
                              </InputMask>
                            </Paper>
                            <Paper
                              className={classes.medium}
                              elevation={0}
                              style={{ width: '99%' }}
                            >
                              <InputMask
                                mask="9999-99"
                                className={classes.input}
                                disabled={!isEditing}
                                placeholder="CNPJ"
                                name="filialCNPJ"
                                value={formValues?.filialCNPJ || selectedGroup?.filialCNPJ}
                                onChange={handleInputChange}
                                error={getErros.includes('cnpjCpf')}
                                onBlur={(event) =>
                                  getErros.includes('cnpjCpf') &&
                                  setErros(
                                    getErros.filter(function (item) {
                                      return item !== 'cnpjCpf';
                                    }),
                                  )
                                }
                              >
                                {() => (
                                  <Input
                                    className={classes.input}
                                    placeholder="CNPJ"
                                    name="filialCNPJ"
                                    error={getErros.includes('cnpjCpf')}
                                  />
                                )}
                              </InputMask>
                            </Paper>
                          </div>
                        </Grid>
                      ) : (
                        <Grid item xs={6}>
                          <label className={classes.label}>CNPJ</label>
                          <Paper className={classes.medium} elevation={0}>
                            <InputMask
                              mask="99.999.999/9999-99"
                              className={classes.input}
                              disabled={!isEditing}
                              placeholder="CNPJ"
                              value={formValues?.cnpjCpf || selectedGroup?.filialCNPJ}
                              name="cnpjCpf"
                              onChange={handleInputChange}
                              error={getErros.includes('raizCnpjCpf')}
                              onBlur={(event) =>
                                getErros.includes('raizCnpjCpf') &&
                                setErros(
                                  getErros.filter(function (item) {
                                    return item !== 'raizCnpjCpf';
                                  }),
                                )
                              }
                            >
                              {() => (
                                <Input
                                  className={classes.input}
                                  placeholder="CPF"
                                  disabled
                                  name="cnpjCpf"
                                />
                              )}
                            </InputMask>
                          </Paper>
                        </Grid>
                      )}

                      <Grid item xs={6}>
                        <label className={classes.label}>Frequência Antecipação</label>
                        <Paper className={classes.medium} elevation={0}>
                          <Input
                            className={classes.input}
                            placeholder="Frequência Antecipação"
                            value={formValues?.frequencia || frequency}
                            disabled
                          />
                        </Paper>
                      </Grid>

                      <Grid item xs={6}>
                        <label className={classes.label}>Razão Social</label>
                        <Paper className={classes.medium} elevation={0}>
                          <Input
                            style={{ textTransform: 'uppercase !important' }}
                            className={classes.input}
                            classes={{ input: classes.inputText }}
                            placeholder="Razão Social"
                            onChange={handleInputChange}
                            value={formValues?.razaoSocial || ''}
                            disabled={!isEditing}
                            error={getErros.includes('RazaoSocial')}
                            onBlur={(event) =>
                              getErros.includes('RazaoSocial') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'RazaoSocial';
                                }),
                              )
                            }
                            name="razaoSocial"
                            inputProps={{
                              minLength: 3,
                              maxLength: 150,
                            }}
                          />
                        </Paper>
                      </Grid>

                      <Grid item xs={6}>
                        <label className={classes.label}>Classificação Fornecedor</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            onChange={(e) =>
                              setFormValues((prev) => ({
                                ...prev,
                                classificacaoFornecedorId: Number(e.target.value),
                              }))
                            }
                            disabled={!isEditing}
                            value={formValues?.classificacaoFornecedorId}
                            name="classificacaoFornecedorId"
                            error={getErros.includes('ClassificacaoFornecedorId')}
                            onBlur={(event) =>
                              getErros.includes('ClassificacaoFornecedorId') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'ClassificacaoFornecedorId';
                                }),
                              )
                            }
                          >
                            <option value="0">FALTA PREENCHER</option>
                            {classifications.map((classificacao) => (
                              <option
                                key={classificacao.classificacaoFornecedorId}
                                value={classificacao.classificacaoFornecedorId}
                              >
                                {classificacao.classificacao}
                              </option>
                            ))}
                          </NativeSelect>
                        </Paper>
                      </Grid>

                      <Grid item xs={6}>
                        <label className={classes.label}>Nome Fantasia</label>
                        <Paper className={classes.medium} elevation={0}>
                          <Input
                            style={{ textTransform: 'uppercase !important' }}
                            className={classes.input}
                            classes={{ input: classes.inputText }}
                            placeholder="Nome Fantasia"
                            value={formValues?.nomeFantasia || ''}
                            disabled={!isEditing}
                            name="nomeFantasia"
                            error={getErros.includes('NomeFantasia')}
                            onBlur={(event) =>
                              getErros.includes('NomeFantasia') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'NomeFantasia';
                                }),
                              )
                            }
                            onChange={handleInputChange}
                            autoComplete="off"
                            inputProps={{
                              minLength: 3,
                              maxLength: 150,
                            }}
                          />
                        </Paper>
                      </Grid>

                      <Grid item xs={6}>
                        <label className={classes.label}>Ramo Atividade</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            onChange={(e) =>
                              setFormValues((prev) => ({
                                ...prev,
                                ramoAtividadeId: Number(e.target.value),
                              }))
                            }
                            className={classes.input}
                            disabled={!isEditing}
                            value={formValues?.ramoAtividadeId}
                            name="ramoAtividadeId"
                            error={getErros.includes('RamoAtividadeId')}
                            onBlur={(event) =>
                              getErros.includes('RamoAtividadeId') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'RamoAtividadeId';
                                }),
                              )
                            }
                          >
                            <option value="0">FALTA PREENCHER</option>
                            {activityBranches.map((activity) => (
                              <option
                                key={activity.ramoAtividadeId}
                                value={activity.ramoAtividadeId}
                              >
                                {activity.ramoAtividade}
                              </option>
                            ))}
                          </NativeSelect>
                        </Paper>
                      </Grid>

                      <Grid item xs={12}>
                        <label className={classes.label}>Observação</label>
                        <Paper className={classes.medium} elevation={0} style={{ width: '99%' }}>
                          <TextareaAutosize
                            onChange={handleInputChange}
                            minRows={3}
                            className={classes.input}
                            classes={{ input: classes.inputText }}
                            value={formValues?.observacao || ''}
                            disabled={!isEditing}
                            name="observacao"
                            style={{ textTransform: 'uppercase !important' }}
                            error={getErros.includes('Observacao')}
                            onBlur={(event) =>
                              getErros.includes('Observacao') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'Observacao';
                                }),
                              )
                            }
                          />
                        </Paper>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>

                <Accordion defaultExpanded>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.summary}>
                    <Typography className={classes.heading}>Endereço</Typography>
                  </AccordionSummary>
                  <AccordionDetails className={classes.details}>
                    <Grid container>
                      <Grid item xs={6}>
                        <label className={classes.label}>Cep</label>
                        <Paper className={classes.medium} elevation={0}>
                          <InputMask
                            mask="99.999-999"
                            value={formValues?.cep || ''}
                            name="cep"
                            className={classes.input}
                            disabled={!isEditing}
                            placeholder="Cep"
                            onChange={(e) =>
                              setFormValues((prev) => ({
                                ...prev,
                                cep: e.target.value.replace(re, '$1.$2-$3'),
                              }))
                            }
                            onBlur={(event) => findCep(formValues.cep)}
                          >
                            {() => (
                              <Input
                                className={classes.input}
                                placeholder="CEP"
                                name="cep"
                                disabled={!isEditing}
                                error={getErros.includes('Cep')}
                              />
                            )}
                          </InputMask>
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Logradouro</label>
                        <Paper className={classes.medium} elevation={0}>
                          <Input
                            className={classes.input}
                            placeholder="Logradouro"
                            name="logradouro"
                            disabled={!isEditing}
                            error={getErros.includes('Logradouro')}
                            onBlur={(event) =>
                              getErros.includes('Logradouro') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'Logradouro';
                                }),
                              )
                            }
                            onChange={handleInputChange}
                            inputProps={{
                              maxLength: 100,
                            }}
                            value={formValues?.logradouro || ''}
                          />
                        </Paper>
                      </Grid>
                      <Grid item xs={6}>
                        <label className={classes.label}>Bairro</label>
                        <Paper className={classes.medium} elevation={0}>
                          <Input
                            className={classes.input}
                            placeholder="Bairro"
                            disabled={!isEditing}
                            error={getErros.includes('Bairro')}
                            onBlur={(event) =>
                              getErros.includes('Bairro') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'Bairro';
                                }),
                              )
                            }
                            name="bairro"
                            value={formValues?.bairro}
                            inputProps={{
                              maxLength: 50,
                            }}
                            onChange={handleInputChange}
                          />
                        </Paper>
                      </Grid>

                      <Grid item xs={6} style={{ position: 'relative' }}>
                        <label className={classes.label}>Estado</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            className={classes.input}
                            value={formValues?.estadoId}
                            name="estadoId"
                            disabled
                            onChange={handleInputChange}
                            error={getErros.includes('EstadoId')}
                            onBlur={(event) =>
                              getErros.includes('EstadoId') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'EstadoId';
                                }),
                              )
                            }
                          >
                            <option value="0">Selecione o estado</option>
                            {estados.map((estado) => (
                              <option key={estado.estadoId} value={estado.estadoId}>
                                {estado.estado}
                              </option>
                            ))}
                          </NativeSelect>
                        </Paper>
                      </Grid>

                      <Grid item xs={6} className={classes.comboNumber}>
                        <div className="input-box">
                          <label className={classes.label}>Número</label>
                          <Paper className={classes.small} elevation={0}>
                            <Input
                              className={classes.input}
                              pattern="[0-9]*"
                              placeholder="Número"
                              name="numero"
                              style={{ padding: '0 4px', width: '20%' }}
                              disabled={!isEditing}
                              inputProps={{
                                maxLength: 6,
                              }}
                              error={getErros.includes('Numero')}
                              onBlur={(event) =>
                                getErros.includes('Numero') &&
                                setErros(
                                  getErros.filter(function (item) {
                                    return item !== 'Numero';
                                  }),
                                )
                              }
                              value={formValues?.numero}
                              onChange={(e) =>
                                setFormValues((prevState) => ({
                                  ...prevState,
                                  numero: Number(e.target.value.replace(/\D/, '')),
                                }))
                              }
                            />
                          </Paper>
                        </div>
                        <div
                          className="input-box"
                          style={{ width: 'calc(80% - 3px)', position: 'relative', right: '6px' }}
                        >
                          <label className={classes.label}>Complemento</label>
                          <Paper className={classes.medium} elevation={0}>
                            <Input
                              className={classes.input}
                              classes={{ input: classes.inputText }}
                              disabled={!isEditing}
                              placeholder="Complemento"
                              name="complemento"
                              inputProps={{
                                maxLength: 50,
                              }}
                              value={formValues?.complemento}
                              onChange={handleInputChange}
                            />
                          </Paper>
                        </div>
                      </Grid>

                      <Grid item xs={6}>
                        <label className={classes.label}>Município</label>
                        <Paper className={classes.medium} elevation={0}>
                          {municipios && (
                            <NativeSelect
                              className={classes.input}
                              value={formValues?.municipioId}
                              name="municipioId"
                              onChange={handleInputChange}
                              disabled={!isRegister || !isEditing}
                              error={getErros.includes('MunicipioId')}
                              onBlur={(event) =>
                                getErros.includes('MunicipioId') &&
                                setErros(
                                  getErros.filter(function (item) {
                                    return item !== 'MunicipioId';
                                  }),
                                )
                              }
                            >
                              <option>
                                {isLoadingCities
                                  ? 'Carregando lista de cidades...'
                                  : 'Selecione o município'}
                              </option>
                              {municipios?.map((municipio) => (
                                <option key={municipio.municipioId} value={municipio.municipioId}>
                                  {municipio.municipio}
                                </option>
                              ))}
                            </NativeSelect>
                          )}
                        </Paper>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>

                {!isRegister && (
                  <Accordion defaultExpanded>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                      className={classes.summary}
                    >
                      <Typography className={classes.heading}>Dados do Registro</Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.details}>
                      <Grid container>
                        <Grid item xs={6}>
                          <label className={classes.label}>Data de Registro</label>
                          <Paper className={classes.medium} elevation={0}>
                            <Input
                              className={classes.input}
                              value={
                                formValues.dataRegistro &&
                                formatDateTimeToRender(formValues.dataRegistro)
                              }
                              readOnly
                              disabled={!isEditing}
                              placeholder="Data do Registro"
                            />
                          </Paper>
                        </Grid>

                        <Grid item xs={6}>
                          <label className={classes.label}>Data da Atualização</label>
                          <Paper className={classes.medium} elevation={0}>
                            <Input
                              className={classes.input}
                              value={
                                formValues.dataAtualizacao
                                  ? formatDateTimeToRender(formValues.dataAtualizacao)
                                  : ''
                              }
                              readOnly
                              disabled={!isEditing}
                              placeholder="Data da Atualização"
                            />
                          </Paper>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                )}
                {!isRegister && (
                  <Accordion defaultExpanded>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel2a-content"
                      id="panel2a-header"
                      className={classes.summary}
                    >
                      <Typography className={classes.heading}>Dados das Propostas</Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.details}>
                      <Grid container>
                        <Grid item xs={6}>
                          <label className={classes.label}>Data da Ultima Proposta</label>
                          <Paper className={classes.medium} elevation={0}>
                            <Input
                              className={classes.input}
                              value={
                                formValues.dataUltimaProposta ?
                                formatDateTimeToRender(formValues.dataUltimaProposta) :
                                ''
                              }
                              readOnly
                              disabled={!isEditing}
                              placeholder="Data da Ultima Proposta"
                            />
                          </Paper>
                        </Grid>

                        <Grid item xs={6}>
                          <label className={classes.label}>Data da Ultima Aprovação</label>
                          <Paper className={classes.medium} elevation={0}>
                            <Input
                              className={classes.input}
                              value={
                                formValues.dataUltimaAprovacao
                                  ? formatDateTimeToRender(formValues.dataUltimaAprovacao)
                                  : ''
                              }
                              readOnly
                              disabled={!isEditing}
                              placeholder="Data da Ultima Aprovação"
                            />
                          </Paper>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                )}
              </form>

              {id && formValues?.grupoFornecedorId && (
                <>
                  <ContactGroup
                    providerId={id}
                    isEditing={isEditing}
                    grupoFornecedorId={formValues.grupoFornecedorId}
                  />
                  <ContactAssGroup
                    providerId={id}
                    isEditing={isEditing}
                    fornecedorId={formValues.fornecedorId}
                    grupoFornecedorId={formValues.grupoFornecedorId}
                  />
                  <ContractMasterAssGroup
                    providerId={id}
                    fornecedorId={formValues.fornecedorId}
                    razaoSocialFornecedor={formValues.razaoSocial}
                  />
                
                </>
              )}
              {id && (
                <BankAccount
                  providerId={id}
                  isEditing={isEditing}
                  isRural={selectedGroup?.produtorRural === 'Sim'}
                />
              )}
              {id && <Anotations providerId={id} isEditing={isEditing} />}
              {id && <Anchors providerId={id} isEditing={isEditing} />}
              {id && <Exceptions providerId={id} isEditing={isEditing} />}

              {(isRegister || isEditing) && (
                <div className={classes.divButton}>
                  <button
                    variant="contained"
                    type="button"
                    onClick={onSubmit}
                    className={classes.button}
                    disable={!auxLoading || !isLoading}
                  >
                    {isRegister ? 'Cadastrar' : 'Atualizar'}
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
